var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBluetape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7401:118326)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.2953,
    cy: 31.2953,
    r: 20.2953,
    fill: "#003353"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3476 22.3016C30.1302 22.3016 28.0837 23.0318 26.4335 24.2664V20.1582H22.4432V31.3038H26.5062C26.9508 28.4703 29.3962 26.3026 32.3476 26.3026C35.6139 26.3026 38.2617 28.9575 38.2617 32.2326C38.2617 35.1419 36.1725 37.5626 33.4164 38.0655V42.1065C38.3828 41.5721 42.252 37.3554 42.252 32.2326C42.252 26.7484 37.8171 22.3016 32.3476 22.3016Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5343 33.272H22.5121C23.0113 37.9578 26.742 41.6712 31.4157 42.1065V38.068C28.9437 37.6771 26.9809 35.7409 26.5343 33.272Z",
    fill: "#00A0F3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7401:118326",
    x: 0,
    y: 0,
    width: 64.5906,
    height: 64.5908,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0820513 0 0 0 0 0.16 0 0 0 0 0.32 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7401:118326"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7401:118326",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBluetape);
export default __webpack_public_path__ + "static/media/IconBluetape.739dd125698cb5aee1abc9caec91990f.svg";
export { ForwardRef as ReactComponent };